import { LOGIN_ERROR } from './HomeConstants'

export const setError = (code = '', extra = null) => {
  const action = {
    type: LOGIN_ERROR,
    payload: { UserFriendlyErrorCode: code, extra },
  }
  return action
}
